export default {
  title: '图层',
  videoResource: '视频',
  audioResource: '音频',
  addGroupWarning: '视频、音频节点无法编组',
  addGroupWarning1: '龙骨、粒子子节点无法编组',
  addGroupWarning2: '快捷布局节点无法编组',
  treeCopyNode: {
    copyNode: {
      name: '复制图层',
    },
    pasteNode: {
      name: '粘贴图层',
      warning: '未复制图层',
    },
    delete: {
      name: '删除图层',
    },
    ungroup: {
      name: '解除编组',
    },
  },
  treePasteNode: {
    name: '粘贴图层',
    warning: '未粘贴图层',
  },
  nodeLabelBar: {
    endEditNameError: '存在重名文本节点，请重新命名',
  },
  actionBar: {
    lock: '锁定',
    unlock: '解锁',
    hiddenNode: '隐藏',
    showNode: '显示',
  },
  video: '视频',
  deleteConfirmTitle: '删除元素/场景',
  deleteConfirmContent: '删除后，可能会导致可玩广告无法正常试玩。确认删除吗？',
  deleteConfirmCancel: '取消',
  deleteConfirmConfirm: '删除',
  layerColor: '图层颜色',
  noColor: '无颜色',
  red: '红色',
  yellow: '黄色',
  green: '绿色',
  blue: '蓝色',
  purple: '紫色',
}
